import { render, staticRenderFns } from "./SurveyStatsHeader.vue?vue&type=template&id=bfdb0880&scoped=true"
import script from "./SurveyStatsHeader.vue?vue&type=script&lang=js"
export * from "./SurveyStatsHeader.vue?vue&type=script&lang=js"
import style0 from "./SurveyStatsHeader.vue?vue&type=style&index=0&id=bfdb0880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdb0880",
  null
  
)

export default component.exports